import { translate } from 'loankeeper-common/helpers'

export default (key: string): string => translate(`frm_sec_RL_add_edit-${key}`)
